import { financings } from './role'

export const queries = {
  financings,
}
export default queries
